import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { useKeycloak } from '../auth/KeycloakAuthProvider';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { authenticated, logout, keycloak } = useKeycloak();
  
  return (
    <div className="site-wrapper">
      {authenticated && (
        <div style={{
          background: 'linear-gradient(90deg, #8C084D, #64062F)',
          color: 'white',
          padding: '4px 0',
          fontSize: '12px',
          fontWeight: '500',
          position: 'sticky',
          top: 0,
          zIndex: 1000
        }}>
          <div className="container">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <i className="fa fa-check-circle" aria-hidden="true"></i> Eingeloggt als <strong>{keycloak?.tokenParsed?.preferred_username}</strong>
              </div>
              <a 
                href="#" 
                onClick={(e) => { e.preventDefault(); logout(); }}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: '11px',
                  padding: '2px 8px',
                  border: '1px solid rgba(255,255,255,0.3)',
                  borderRadius: '3px',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
              >
                <i className="fa fa-sign-out" aria-hidden="true"></i> Abmelden
              </a>
            </div>
          </div>
        </div>
      )}
      <Header />
      <main className="site-content" style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 150px)',  // Viewport minus Header/Footer
        overflow: 'hidden'  // Verhindert Page-Scroll
      }}>
        <div className="container-fluid" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div className="row bg2" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div className="container" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <div className="row" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="col-xs-12" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                  <div className="trenner1"></div>
                  <div className="padt-1"></div>
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
